import { SET_SNACKBAR } from './actionType';

export const setSnackbar = (data) => {
  return { type: SET_SNACKBAR, payload: data };
};
